export const MA_EQUIPMENT_LOADER = {
  desktop: `<div class="cui-grid cui-container">
  <div class="cui-skeleton-paragraph -spacing--top-64 -spacing--bottom-40">
    <div class="cui-skeleton-paragraph__content" style="width: 160px">
      <div class="cui-skeleton__item cui-skeleton__description"></div>
    </div>
  </div>
  <div style="display: flex; flex-wrap: wrap; column-gap: 40px">
    <div class="cui-skeleton-heading -size--medium" style="flex-grow: 1">
      <div class="cui-skeleton-heading__content" style="width: 100%">
        <div class="cui-skeleton__item cui-skeleton-heading__title display-none display-md-block"></div>
        <div class="cui-skeleton__item cui-skeleton-heading__title display-block display-md-none" style="width: 343px"></div>
        <div class="cui-skeleton__item cui-skeleton__description"></div>
      </div>
    </div>
    <div class="cui-skeleton-button -size--large display-none display-md-block">
      <div class="cui-skeleton-button__content" style="width: 160px">
        <div class="cui-skeleton__item cui-skeleton-button__button"></div>
      </div>
    </div>
    <div class="cui-skeleton-button -size--large -spacing--top-40 display-block display-md-none" style="width: 100%">
      <div class="cui-skeleton-button__content" style="width: 100%">
        <div class="cui-skeleton__item cui-skeleton-button__button"></div>
      </div>
    </div>
  </div>
  <div>
    <div class="-spacing--top-64 display-none display-xl-block"></div>
    <div class="-spacing--top-40 display-none display-md-block display-xl-none"></div>
    <div class="-spacing--top-24 display-block display-md-none"></div>
  </div>
  <div style="display: flex; gap: 24px">
    <div class="cui-skeleton-input -size--medium display-none display-lg-block" style="width: 100%; max-width: 540px">
      <div class="cui-skeleton-input__content" style="width: 100%">
        <div class="cui-skeleton__item cui-skeleton-input__field"></div>
      </div>
    </div>
    <div class="cui-skeleton-input -size--medium display-block display-lg-none" style="width: 100%; max-width: 576px">
      <div class="cui-skeleton-input__content" style="width: 100%">
        <div class="cui-skeleton__item cui-skeleton-input__field"></div>
      </div>
    </div>
    <div class="cui-skeleton-button -size--large">
      <div class="cui-skeleton-button__content display-none display-lg-block" style="width: 96px">
        <div class="cui-skeleton__item cui-skeleton-button__button"></div>
      </div>
      <div class="cui-skeleton-button__content display-none display-md-block display-lg-none" style="width: 120px">
        <div class="cui-skeleton__item cui-skeleton-button__button"></div>
      </div>
      <div class="cui-skeleton-button__content display-block display-md-none" style="width: 95px">
        <div class="cui-skeleton__item cui-skeleton-button__button"></div>
      </div>
    </div>
  </div>
  <div>
    <div class="-spacing--top-40 display-none display-md-block"></div>
    <div class="-spacing--top-24 display-block display-md-none"></div>
  </div>
  <div style="display: flex; gap: 16px">
    <div class="cui-skeleton-button -size--large" style="width: 100%; max-width: 120px">
      <div class="cui-skeleton-button__content" style="width: 100%">
        <div class="cui-skeleton__item cui-skeleton-button__button"></div>
      </div>
    </div>
    <div class="cui-skeleton-button -size--large" style="width: 100%; max-width: 120px">
      <div class="cui-skeleton-button__content" style="width: 100%">
        <div class="cui-skeleton__item cui-skeleton-button__button"></div>
      </div>
    </div>
    <div class="cui-skeleton-button -size--large" style="width: 100%; max-width: 120px">
      <div class="cui-skeleton-button__content" style="width: 100%">
        <div class="cui-skeleton__item cui-skeleton-button__button"></div>
      </div>
    </div>
  </div>
  <div>
    <div class="-spacing--top-64 display-none display-xl-block"></div>
    <div class="-spacing--top-40 display-none display-lg-block display-xl-none"></div>
    <div class="-spacing--top-24 display-block display-lg-none"></div>
  </div>
  <div class="cui-grid">
    <div class="cui-row">
      <div class="cui-col-lg-6 cui-col-md-4">
        <div class="cui-skeleton-rectangle display-none display-lg-block">
          <div class="cui-skeleton__item -spacing--bottom-32" style="height: 164px"></div>
          <div class="cui-skeleton__item -spacing--bottom-32" style="height: 164px"></div>
          <div class="cui-skeleton__item -spacing--bottom-32" style="height: 164px"></div>
        </div>
        <div class="cui-skeleton-rectangle display-block display-lg-none">
          <div class="cui-skeleton__item -spacing--bottom-24" style="height: 164px"></div>
          <div class="cui-skeleton__item -spacing--bottom-24" style="height: 164px"></div>
          <div class="cui-skeleton__item -spacing--bottom-24" style="height: 164px"></div>
        </div>
      </div>
      <div class="cui-col-lg-6 cui-col-md-4">
        <div class="cui-skeleton-rectangle display-none display-lg-block">
          <div class="cui-skeleton__item -spacing--bottom-32" style="height: 164px"></div>
          <div class="cui-skeleton__item -spacing--bottom-32" style="height: 164px"></div>
          <div class="cui-skeleton__item -spacing--bottom-32" style="height: 164px"></div>
        </div>
        <div class="cui-skeleton-rectangle display-block display-lg-none">
          <div class="cui-skeleton__item -spacing--bottom-24" style="height: 164px"></div>
          <div class="cui-skeleton__item -spacing--bottom-24" style="height: 164px"></div>
          <div class="cui-skeleton__item -spacing--bottom-24" style="height: 164px"></div>
        </div>
      </div>
    </div>
  </div>
</div>`
};
